<template>
  <div class="addressMana">
    <loading v-if="loading"></loading>
    <AddressList
      v-model="chosenAddressId"
      :list="list"
      :disabled-list="disabledList"
      disabled-text=""
      default-tag-text="默认"
      @add="onAdd"
      @edit="onEdit"
    />
  </div>
</template>

<script>
import { AddressList, Toast } from "vant";
import { initOpenid } from "@/utils/getOpenid";
import { addressList } from "@/api/officialAccount/index.js";
export default {
  components: { AddressList },
  data() {
    return {
      chosenAddressId: "1",
      list: [],
      loading: true,
      disabledList: [], // 距离太远不可送
    };
  },
  created() {
    console.log(this.$route.params, "头部参数");
    this.chosenAddressId = this.$store.state.offici.address.id;
    console.log(this.chosenAddressId);
    if (this.$route.params.message) Toast(this.$route.params.message);
    if (
      process.env.NODE_ENV === "development" &&
      !localStorage.getItem("openId")
    ) {
      localStorage.setItem("openId", "dev_test_openid");
    }
    if (!localStorage.getItem("openId")) {
      initOpenid(this.addressListhanlde);
    } else {
      this.addressListhanlde();
    }
  },
  mounted() {
    var box = document.getElementsByClassName("van-address-list__bottom");
    var box1 = document.getElementsByClassName("van-button__text");
    box1.innerText = "新建收货地址";
    console.log(box);
    var div = document.createElement("div");
    div.innerText = "确定";
    div.style.width = "100%";
    div.style.height = "40px";
    div.style.margin = "20px 0";
    div.style.background = "#fff";
    div.style.borderRadius = "400px";
    div.style.textAlign = "center";
    div.style.lineHeight = "40px";
    div.style.fontSize = "14px";
    div.onclick = () => {
      this.$router.push({ name: "appraise" });
    };
    box[0].appendChild(div);
  },
  beforeDestroy() {
    console.log(this.chosenAddressId, this.list);
    this.list.map((item) => {
      if (this.chosenAddressId == item.id) {
        this.$store.commit("offici/setAddress", item);
      }
    });
  },
  methods: {
    async addressListhanlde() {
      this.openId = localStorage.getItem("openId");
      const { data, code } = await addressList({
        openid: this.openId,
      });
      if (code !== "0000000") {
        this.loading = false;
        return;
      }
      this.list = [];
      data.map((item) => {
        this.list.push({
          id: item.id,
          name: item.name,
          tel: item.phone,
          address:
            item.province +
            "," +
            item.city +
            "," +
            item.area +
            "," +
            item.detail,
          isDefault: item.type ? true : false,
          province: item.province,
          city: item.city,
          detail: item.detail,
          areaCode: item.code,
          county: item.area,
        });
        if (!this.chosenAddressId && item.type) this.chosenAddressId = item.id;
      });
      this.loading = false;
      console.log(this.chosenAddressId);
    },
    onAdd() {
      this.$router.push({ path: "/addressEdit" });
    },
    onEdit(item, index) {
      console.log("编辑地址:" + index, item);
      const address = {
        id: item.id,
        name: item.name,
        tel: item.tel,
        isDefault: item.isDefault,
        province: item.province,
        city: item.city,
        addressDetail: item.detail,
        areaCode: item.areaCode,
        county: item.county,
      };
      this.$router.push({
        path: "/addressEdit",
        query: { address: JSON.stringify(address) },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.addressMana {
  height: 100vh;
  overflow-y: auto;
}
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
/deep/.van-address-list {
  overflow-y: auto;
  padding: 12px 12px 112px;
}
/deep/.van-address-list__bottom {
  background: #f1f1f2;
}
/deep/.van-button--danger {
  background-color: #60bb46;
  border: 1px solid #60bb46;
}
/deep/.van-tag--danger {
  background-color: #60bb46;
}
/deep/.van-address-item .van-radio__icon--checked .van-icon {
  background-color: #60bb46;
  border-color: #60bb46;
}
</style>
